var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("带货排行榜活动管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "search_criteria" }, [
        _c("div", { staticStyle: { "margin-left": "0" } }, [
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: "输入活动名称查询", clearable: "" },
                model: {
                  value: _vm.queryData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "title", $$v)
                  },
                  expression: "queryData.title",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择活动上下线状态", clearable: "" },
                model: {
                  value: _vm.queryData.rankSwitch,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "rankSwitch", $$v)
                  },
                  expression: "queryData.rankSwitch",
                },
              },
              [
                _c("el-option", { attrs: { value: 0, label: "下线" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 1, label: "上线" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择渠道类型", clearable: "" },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { value: "TB", label: "淘宝" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "JD", label: "京东" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "PDD", label: "拼多多" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "WPH", label: "唯品会" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "DY", label: "抖音" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "ALL", label: "全渠道" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择统计类型", clearable: "" },
                model: {
                  value: _vm.queryData.indexType,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "indexType", $$v)
                  },
                  expression: "queryData.indexType",
                },
              },
              [
                _c("el-option", { attrs: { value: "1", label: "GMV" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "2", label: "佣金" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "3", label: "订单量" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "fit-content" } },
          [
            _c("el-date-picker", {
              attrs: {
                "value-format": "yyyy-MM-dd HH:mm:ss",
                type: "datetimerange",
                "range-separator": "-",
                "start-placeholder": "活动开始时间",
                "end-placeholder": "活动结束时间",
              },
              model: {
                value: _vm.value1,
                callback: function ($$v) {
                  _vm.value1 = $$v
                },
                expression: "value1",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            staticStyle: { width: "fit-content", height: "40px" },
          },
          [
            _c(
              "el-button",
              {
                staticStyle: { height: "40px" },
                attrs: { type: "primary" },
                on: { click: _vm.onInquireList },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                staticStyle: { height: "40px" },
                attrs: { type: "info", plain: "" },
                on: { click: _vm.onInitializeList },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.onRecharge },
              },
              [_vm._v("新建+")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "pull_down_box" },
            [
              _c(
                "el-button",
                { staticClass: "ml10", attrs: { type: "info", plain: "" } },
                [
                  _c("img", {
                    staticStyle: { width: "16px", height: "16px" },
                    attrs: {
                      src: require("@/assets/member/UserManage/icon1.png"),
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: {
                      width: "12px",
                      height: "12px",
                      "margin-left": "10px",
                    },
                    attrs: {
                      src: require("@/assets/member/UserManage/icon2.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "down_item" }, [
                _c(
                  "div",
                  { staticClass: "style:height:100%" },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        on: { change: _vm.onCheckBox },
                        model: {
                          value: _vm.checkList,
                          callback: function ($$v) {
                            _vm.checkList = $$v
                          },
                          expression: "checkList",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "活动名称" } },
                              [_vm._v("活动名称")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c("el-checkbox", { attrs: { label: "头图" } }, [
                              _vm._v("头图"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "渠道类型" } },
                              [_vm._v("渠道类型")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "报名开始时间" } },
                              [_vm._v("报名开始时间")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "报名结束时间" } },
                              [_vm._v("报名结束时间")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "报名人数" } },
                              [_vm._v("报名人数")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "累计发放红包数" } },
                              [_vm._v("累计发放红包数")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "实际奖励总金额" } },
                              [_vm._v("实际奖励总金额")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "活动状态" } },
                              [_vm._v("活动状态")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "活动上下线状态" } },
                              [_vm._v("活动上下线状态")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "活动开始时间" } },
                              [_vm._v("活动开始时间")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "活动结束时间" } },
                              [_vm._v("活动结束时间")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "结算状态" } },
                              [_vm._v("结算状态")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "结算时间" } },
                              [_vm._v("结算时间")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "创建时间" } },
                              [_vm._v("创建时间")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt10 mb10" },
                          [
                            _c(
                              "el-checkbox",
                              { attrs: { label: "数据更新时间" } },
                              [_vm._v("数据更新时间")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.tableData,
                "tooltip-effect": "dark",
              },
            },
            [
              _vm.checkList.includes("活动名称")
                ? _c("el-table-column", {
                    attrs: {
                      label: "活动名称",
                      prop: "title",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("头图")
                ? _c("el-table-column", {
                    attrs: { label: "头图", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("img", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: { src: scope.row.mainPic, alt: "" },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      802032124
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("渠道类型")
                ? _c("el-table-column", {
                    attrs: {
                      label: "渠道类型",
                      prop: "unionCode",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.typeList[scope.row.unionCode]) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2572238815
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "统计类型",
                  prop: "indexType",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.tgList[scope.row.indexType * 1] || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.checkList.includes("报名开始时间")
                ? _c("el-table-column", {
                    attrs: {
                      label: "报名开始时间",
                      prop: "signStartTime",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("报名结束时间")
                ? _c("el-table-column", {
                    attrs: {
                      label: "报名结束时间",
                      prop: "signEndTime",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("报名人数")
                ? _c("el-table-column", {
                    attrs: {
                      label: "报名人数",
                      prop: "signCount",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("累计发放红包数")
                ? _c("el-table-column", {
                    attrs: {
                      label: "累计数据",
                      prop: "rankValue",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "奖励门槛",
                  prop: "rankLimit",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _vm.checkList.includes("实际奖励总金额")
                ? _c("el-table-column", {
                    attrs: {
                      label: "实际奖励总金额",
                      prop: "rewardValue",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("活动上下线状态")
                ? _c("el-table-column", {
                    attrs: {
                      label: "活动上下线状态",
                      prop: "rankSwitch",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.rankSwitch === 0
                                ? _c("div", [_vm._v("下线")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rankSwitch === 1
                                ? _c("div", [_vm._v("上线")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2201066832
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("活动状态")
                ? _c("el-table-column", {
                    attrs: {
                      label: "活动状态",
                      prop: "rankStatus",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.rankStatus === 0
                                ? _c("div", [_vm._v("未开始")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rankStatus === 1
                                ? _c("div", [_vm._v("进行中")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rankStatus === 2
                                ? _c("div", [_vm._v("已完成")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rankStatus === 3
                                ? _c("div", [_vm._v("已结束")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2522361019
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("活动开始时间")
                ? _c("el-table-column", {
                    attrs: {
                      label: "活动开始时间",
                      prop: "rankStartTime",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("活动结束时间")
                ? _c("el-table-column", {
                    attrs: {
                      label: "活动结束时间",
                      prop: "rankEndTime",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("结算状态")
                ? _c("el-table-column", {
                    attrs: {
                      label: "结算状态",
                      prop: "settleStatus",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.settleStatus === 0
                                ? _c("div", [_vm._v("未结算")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.settleStatus === 1
                                ? _c("div", [_vm._v("已结算")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1929299945
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("结算时间")
                ? _c("el-table-column", {
                    attrs: {
                      label: "结算时间",
                      prop: "settleTime",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkList.includes("创建时间")
                ? _c("el-table-column", {
                    attrs: {
                      label: "创建时间",
                      prop: "createTime",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "数据更新时间",
                  prop: "updateTime",
                  align: "center",
                  if: "checkList.includes('数据更新时间')",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "300px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "success" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDetails(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteRank(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "5px" } },
                            [
                              scope.row.settleStatus === 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "warning" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkOut(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("去结算")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "info" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyLink(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("复制链接")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20 page_box" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SuperPopup", {
        ref: "superPopup",
        attrs: { "action-type": "income" },
        on: { upFresh: _vm.listRank, fresh: _vm.onInquireList },
      }),
      _vm._v(" "),
      _c("SuperActivityDetails", { ref: "superActivityDetails" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-bottom": "20px",
          color: "#f59a23",
          "background-color": "#fdf6ec",
          padding: "20px",
          "border-radius": "20px",
        },
      },
      [
        _c("div", [
          _vm._v(
            "\n      请注意，活动数据大约每隔3小时会自动刷新，如果您需要获取最新信息，请留意列表末尾“数据更新时间”\n    "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }